export default function HeroStats({ stats }) {
  return (
    <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
      {stats.map((s) => (
        <div key={s.label} data-testid={`hero-stat-${s.label}`}>
          <div className="font-heading text-3xl sm:text-4xl text-[var(--primary)]">
            {s.value}
          </div>
          <div className="text-xs font-semibold uppercase tracking-wider text-[var(--muted)] mt-1">
            {s.label}
          </div>
        </div>
      ))}
    </div>
  );
}
